import Vue from 'vue';
import Vuex from 'vuex';

import baseIndex from 'viralstyle-ui/src/baseIndex';
import base from './domains/base/store';
import campaigns from './domains/campaigns/store';
import orders from './domains/orders/store';
import promotions from './domains/promotions/store';
import stores from './domains/stores/store';
import settings from './domains/settings/store';
import whitelabel from './domains/whitelabel/store';

Vue.use(Vuex);

baseIndex.actions = { ...baseIndex.actions, ...base.actions };
baseIndex.state = { ...baseIndex.state, ...base.state };
baseIndex.mutations = { ...baseIndex.mutations, ...base.mutations };
baseIndex.getters = { ...baseIndex.getters, ...base.getters };

const store = new Vuex.Store({
  ...baseIndex,
  modules: {
    campaigns,
    orders,
    promotions,
    stores,
    settings,
    whitelabel,
  },
  strict: process.env.NODE_ENV === 'development',
});

if (module.hot) {
  module.hot.accept([
    'viralstyle-ui/src/baseIndex',
    './domains/base/store',
    './domains/campaigns/store',
    './domains/orders/store',
    './domains/promotions/store',
    './domains/stores/store',
    './domains/settings/store',
    './domains/whitelabel/store',
  ], () => {
    let baseIndexHot = require('viralstyle-ui/src/baseIndex').default,
      baseHot = require('./domains/base/store').default;

    baseIndexHot.actions = { ...baseIndexHot.actions, ...baseHot.actions };
    baseIndexHot.state = { ...baseIndexHot.state, ...baseHot.state };
    baseIndexHot.mutations = { ...baseIndexHot.mutations, ...baseHot.mutations };

    store.hotUpdate({
      actions: baseIndexHot.actions,
      state: baseIndexHot.state,
      mutations: baseIndexHot.mutations,
      getters: require('./domains/base/store').getters,
      modules: {
        campaigns: require('./domains/campaigns/store').default,
        orders: require('./domains/orders/store').default,
        promotions: require('./domains/promotions/store').default,
        stores: require('./domains/stores/store').default,
        settings: require('./domains/settings/store').default,
        whitelabel: require('./domains/whitelabel/store').default,
      },
    });
  });
}

export default store;